<template>
  <section>
    <div class="mod-block">
      <h3 class="title">打包组合商品</h3>
      <el-button type="success" @click="addProducts">添加组合商品</el-button>
      <el-form ref="form" :model="form" label-width="80px" size="mini" class="mod-form">
        <el-form-item v-if="form.list.length < 1" label-width="0px" prop="list" required :rules="[{validator: $validate.required}]" style="padding-bottom: 10px;"></el-form-item>
        <template v-else>
          <div class="groups" v-for="(item, index) in form.list" :key="index">
            <el-form-item label="商品编码" :prop="'list.' + index + '.childItem'" required :rules="[{validator: $validate.required}]">
              {{item.childItem}}
            </el-form-item>
            <el-form-item label="商品名称" :prop="'list.' + index + '.childItemDesc'" required :rules="[{validator: $validate.required}]">
              <div class="text-ellipsis">{{item.childItemDesc}}</div>
            </el-form-item>
            <el-form-item label="数量" :prop="'list.' + index + '.childItemNum'" required :rules="[{validator: $validate.required},{ pattern: /(^[1-9](\d+)?$)/, message: '请输入正整数', trigger: 'blur' }]">
              {{item.childItemNum}}
              <!-- <el-input v-model="item.childItemNum"></el-input> -->
            </el-form-item>
            <div class="btns">
              <el-link type="primary" @click="edit(item)">编辑</el-link>
              <el-link type="danger" @click="del(index)">删除</el-link>
            </div>
          </div>
        </template>
      </el-form>
    </div>
    <!-- 新增 -->
    <CombinationProductsAdd ref="addItem" @sure="handleAdd"></CombinationProductsAdd>
  </section>
</template>
<script>
  import CombinationProductsAdd from './combination-products-add.vue'
  export default {
    inject: ['getComData'],
    components: {CombinationProductsAdd},
    data () {
      return {
        form: {
          list: [
            // {
            //   childItem: '', // 商品编码
            //   childItemDesc: '', // 商品名称
            //   childItemNum: '', // 商品数量
            //   itemPackaged: '' // 商品打包类型
            // }
          ]
        }
      }
    },
    computed: {
      isSimple () {
        return this.getComData().typeId == '2'
      }
    },
    methods: {
      edit (item) {
        this.$refs.addItem.edit(item)
      },
      addProducts () {
        // 简单商品只能添加一条
        if (this.isSimple && this.form.list.length >= 1) {
          this.$message.warning('简单组合商品仅允许录入一个打包商品')
          return
        }
        this.$refs.addItem.isEdit = false
        this.$refs.addItem.visible = true
      },
      handleAdd (data) {
        // 简单组合
        if (this.isSimple && this.$refs.addItem.isEdit) {
          this.form.list = []
          this.form.list.push({itemPackaged: 0, ...data})
          return
        }
        if(!this.form.list.find(item => item.childItem === data.childItem)){
          let type = this.isSimple ? 0 : 1 // 商品打包类型(0简单商品，1.复杂商品)
          this.form.list.push({itemPackaged: type, ...data})
        } else {
          // 复杂编辑/非编辑
          if (!this.$refs.addItem.isEdit) {
            this.$message.warning('同一商品编码不允许重复添加')
          } else {
            this.form.list.forEach(item => {
              if (item.childItem == data.childItem) {
                Object.assign(item, data)
              }
            })
          }
        }
      },
      del (index) {
        this.$confirm('确认删除选中新品?').then(rs => {
          this.form.list.splice(index, 1)
        }).catch(rs => {})
      }
    },
    mounted () {
      let packagedList = this.getComData().editData.packagedList
      if (packagedList && packagedList.length > 0) {
        this.form.list = Object.assign([], packagedList)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 10px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
    .groups {
      overflow: hidden;
    }
    .btns {
      padding-top: 15px;
    }
  }
  .mod-form {
    margin-top: 10px;
    .groups {
      .el-form-item {
        float: left;
        width: 190px;
        margin-bottom: 12px!important;
        border: 1px solid #ddd;
        padding: 3px;
        border-radius: 3px;
        margin-right: 10px;
      }
      /deep/ .label-text .el-form-item__label {
        line-height: 14px;
      }
      /deep/ .el-form-item__label {
        text-align: center;
        padding: 0 0 0 0;
      }
      /deep/ .el-input__inner {
        width: 100px;
      }
      /deep/ .el-form-item__content {
        font-size: 12px;
      }
      .mod-tag {
        background: #8400FF;
        color: #fff;
        border-radius: 4px;
        font-size: 12px;
        font-style: normal;
        padding: 2px;
      }
      .btns {
        float: left;
        padding-top: 8px;
      }
      .text-ellipsis{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/complex-combine/combination-products.vue